import { WidgetDefinition } from '../models/WidgetDefinition';

export const SeriesSelectionWidgetDefinition: WidgetDefinition = {
    baseType: 'seriesSelection',
    group: 'Charts',
    hasImage: false,
    highlights: ['A widget for select series'],
    icon: 'fa-table',
    sortingOrder: 0,
    title: 'Series Selection',
    type: 'seriesSelection'
};